<template>
  <div>
    <el-dialog title="审核" :visible.sync="auditDialog" width="60%" @closed="handleClose" :modal-append-to-body="false">
      <div class="log-container">
        <div v-if="beforeUpdate.id" class="before-update">
          <h3>修改前</h3>
          <el-form :model.sync="beforeUpdate" label-width="100px">
            <el-form-item prop="rightsCode" label="权益编号">
              {{ beforeUpdate.rightsCode }}
            </el-form-item>
            <el-form-item label="权益名称">
              {{ beforeUpdate.rightsName }}
            </el-form-item>
            <el-form-item label="描述文案">
              <span v-if="beforeUpdate.description">{{ beforeUpdate.description }}</span>
              <span v-else>暂无描述</span>
            </el-form-item>
            <el-form-item label="客户端类型">
              <div style="90%">
                <span v-for="(item, index) in beforeUpdate.clientTypes" :key="item">{{ item }}{{ index + 1 ===
                  beforeUpdate.clientTypes.length ? '' : '，' }}</span>
              </div>

            </el-form-item>
            <el-form-item label="限制参数">
              <span v-for="(item, index) in beforeUpdate.limitParams" :key="item">{{ item }}{{ index + 1 ===
                beforeUpdate.limitParams.length ? '' : '，' }}</span>
            </el-form-item>
            <el-form-item label="类型状态">
              {{ beforeUpdate.state }}
            </el-form-item>
            <el-form-item label="备注">
              <span v-if="beforeUpdate.remark">{{ beforeUpdate.remark }}</span>
              <span v-else>暂无备注</span>
            </el-form-item>
          </el-form>
        </div>
        <div class="after-update">
          <h3>修改后</h3>
          <el-form :model.sync="afterUpdate" label-width="100px">
            <el-form-item label="权益编号">
              {{ afterUpdate.rightsCode }}
            </el-form-item>
            <el-form-item label="权益名称">
              {{ afterUpdate.rightsName }}
            </el-form-item>
            <el-form-item label="描述文案">
              <span v-if="afterUpdate.description">{{ afterUpdate.description }}</span>
              <span v-else>暂无描述</span>
            </el-form-item>
            <el-form-item label="客户端类型">
              <div style="width: 90%;">
                <span v-for="(item, index) in afterUpdate.clientTypes" :key="item">{{ item }}{{ index + 1 ===
                  afterUpdate.clientTypes.length ? '' : '，' }}</span>
              </div>

            </el-form-item>
            <el-form-item label="限制参数">
              <span v-for="(item, index) in afterUpdate.limitParams" :key="item">{{ item }}{{ index + 1 ===
                afterUpdate.limitParams.length ? '' : '，' }}</span>
            </el-form-item>
            <el-form-item label="类型状态">
              {{ afterUpdate.state }}
            </el-form-item>
            <el-form-item label="备注">
              <span v-if="afterUpdate.remark">{{ afterUpdate.remark }}</span>
              <span v-else>暂无备注</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 确认提交审核按钮 -->
      <div v-if="!showAuditOpinion" class="dialog-footer">
        <el-button type="primary" @click="handleSubmitAudit">确认提交审核</el-button>
      </div>
      <!-- 审核意见 -->
      <div v-if="showAuditOpinion">
        <div class="dialog-footer">
          <el-button @click="handleReject">审核不通过</el-button>
          <el-button type="primary" @click="handlePass">审核通过</el-button>
        </div>
        <div class="dialog-footer">
          <el-input style="width: 60%;" type="textarea" show-word-limit :autosize="{ minRows: 2, maxRows: 10 }"
            maxlength="999" placeholder="审核意见" v-model="auditOpinion"></el-input>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  submitAudit,
  auditPass,
  auditReject
} from "@/api/memberNew/memberRight";
import Message from "@/components/Message";
export default {
  props: {
    /** 对话框的显隐 */
    auditDialog: {
      type: Boolean,
      default: false
    },
    /** 审核意见的显隐 */
    showAuditOpinion: {
      type: Boolean,
      default: false
    },
    /** 修改前的数据 */
    beforeUpdate: {
      type: Object,
      default: () => {
        return {
          rightsCode: "",
          rightsName: "",
          description: "",
          clientTypes: [],
          limitParams: "",
          state: 1,
          remark: ""
        };
      }
    },
    /** 修改后的数据 */
    afterUpdate: {
      type: Object,
      default: () => {
        return {
          rightsCode: "",
          rightsName: "",
          description: "",
          clientTypes: [],
          limitParams: "",
          state: 1,
          remark: ""
        };
      }
    }
  },
  data() {
    return {
      /** 审核意见 */
      auditOpinion: ""
    };
  },

  methods: {
    /** 对话框关闭 */
    handleClose() {
      /** 清空数据 */
      this.beforeUpdate = {};
      this.afterUpdate = {};
      this.$emit("update:auditDialog", false);
      this.$emit("update:showAuditOpinion", false);

    },
    /** 确认提交审核 */
    async handleSubmitAudit() {
      /** 调用接口 */
      const { data } = await submitAudit(this.afterUpdate.id);
      console.log("确认提交审核接口的响应", data);
      /** 如果成功 提示用户 */
      if (data.code === 200) {
        Message.success("提交审核成功");
      }
      this.$emit("update:auditDialog", false);
      this.$emit("update:showAuditOpinion", false);
      this.$emit("updateData");
    },
    /** 审核通过事件 */
    async handlePass() {
      /** 调用接口 */
      const { data } = await auditPass({
        id: this.afterUpdate.id,
        auditOpinion: this.auditOpinion
      });
      /** 如果成功则提示用户 */
      if (data.code === 200) {
        Message.success("审核通过");
      }
      console.log("审核通过的响应", data);
      this.$emit("update:auditDialog", false);
      this.$emit("update:showAuditOpinion", false);
      this.$emit("updateData");
    },
    /** 审核拒绝事件 */
    async handleReject() {
      /** 调用接口 */
      const { data } = await auditReject({
        id: this.afterUpdate.id,
        auditOpinion: this.auditOpinion
      });
      /** 如果成功则提示用户 */
      if (data.code === 200) {
        Message.success("审核拒绝成功");
      }
      console.log("审核拒绝的响应", data);
      this.$emit("update:auditDialog", false);
      this.$emit("update:showAuditOpinion", false);
      this.$emit("updateData");
    }
  }
};
</script>

<style lang="scss" scoped>
.log-container {
  display: flex;

  .before-update {
    padding: 10px;
    flex: 1;
    background-color: #f2f2f2;
    /** 水平垂直居中 */
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    // align-items: center;
    margin-right: 20px;

    h3 {
      text-align: center;
    }
  }

  .after-update {
    flex: 1;
    padding: 10px;
    /** 水平垂直居中 */
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    // align-items: center;
    background-color: #f2f2f2;

    h3 {
      text-align: center;
    }
  }

  ::v-deep .el-form-item__label {
    /** 字体加粗 */
    font-weight: bold !important;
    text-align: left;
    font-size: 15px;
  }
}

.dialog-footer {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
